import React, { memo, useCallback } from 'react';
import { useI18n } from '../../../i18n';
import SuccessPicture from '../assets/pay-ship-success-picture.svg';
import S from './style/MarketPayConfirmationSuccess';

const i18nKey = (value: string) => `dlv_mp_confirmation_success_${value}`;

function MarketPayConfirmationSuccess({
  desktop,
  buttonUrl,
  onClick,
}: {
  desktop: boolean | null;
  buttonUrl: string;
  onClick: () => void;
}) {
  const i18n = useI18n();
  const getI18n = useCallback((subkey: string) => i18n(i18nKey(subkey)), []);

  return (
    <>
      <S.Title>{getI18n('title')}</S.Title>
      <S.Wrapper>
        <S.DesktopCols>
          <S.PictureColumn>
            <SuccessPicture />
          </S.PictureColumn>
          <S.InfoColumn>
            <S.InfoPar>{getI18n('info1')}</S.InfoPar>
            <S.InfoPar>{getI18n('info2')}</S.InfoPar>
            <S.InfoPar>
              <S.BoldText>{getI18n('info3')}</S.BoldText>
            </S.InfoPar>
            <S.InfoPar>{getI18n('info4')}</S.InfoPar>
            <S.ButtonContainer>
              {desktop ? (
                <S.ConfirmationButton as="a" href={buttonUrl}>
                  {getI18n('toorder')}
                </S.ConfirmationButton>
              ) : (
                <S.ConfirmationButton
                  data-testid="mobile-btn"
                  expanded
                  onClick={() => onClick && onClick()}
                >
                  {getI18n('toorder')}
                </S.ConfirmationButton>
              )}
            </S.ButtonContainer>
          </S.InfoColumn>
        </S.DesktopCols>
      </S.Wrapper>
    </>
  );
}

export default memo(MarketPayConfirmationSuccess);
